// Admin → Schools — layout route.
//
// `_authed.schools.$id` nests under this file, so it MUST render an <Outlet/>
// or the child never mounts. Before 2026-08-15 this file was both the layout
// AND the list with no Outlet, so /schools/$id rendered the list instead of
// the detail view. The list now lives in `_authed.schools.index.tsx`.
//
// Schools are DARK for the families-only MVP (CLAUDE.md §2) — this stays
// compiling and routable so Phase 2 is additive. Do not delete.

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/schools')({
  component: () => <Outlet />,
});
